import { render, staticRenderFns } from "./order-shipment-addresses.vue?vue&type=template&id=6005e0ae&"
import script from "./order-shipment-addresses.vue?vue&type=script&lang=js&"
export * from "./order-shipment-addresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports